var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogog013(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 22,
    viewBox: "0 0 77 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo g-01 3",
    clipPath: "url(#clip0_2312_5723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.5646 6.79371V4.33887H30.6344C27.4053 4.33887 24.7559 6.98095 24.7559 10.1847C24.7559 13.4093 27.4053 16.0306 30.6551 16.0306C33.8841 16.0306 36.5749 13.4093 36.5749 10.2575C36.5853 9.01972 36.2024 7.8131 35.4883 6.79371H36.5646ZM30.6861 13.5757C28.8749 13.5757 27.4571 12.0675 27.4571 10.1431C27.4571 8.31239 28.9267 6.79371 30.6654 6.79371C32.4559 6.79371 33.8944 8.32279 33.8944 10.1847C33.8944 12.0571 32.4455 13.5757 30.6861 13.5757Z",
    fill: "#FF1C5C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.2898 19.2225C28.6584 18.9105 28.141 18.4008 27.8305 17.7559H24.9844C25.7295 20.2835 28.0375 22.0102 30.6559 21.9998C33.3467 21.9998 35.665 20.1795 36.3584 17.7559H33.502C32.7361 19.3265 30.8525 19.9819 29.2898 19.2225Z",
    fill: "#FF1C5C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3052 4.32715C17.2741 4.32715 17.2534 4.32715 17.2224 4.32715C14.0037 4.34795 11.4267 6.99003 11.4474 10.2146C11.4474 13.4912 14.0762 16.0293 17.4708 16.0293C19.7166 16.0293 22.0245 14.7602 22.7697 12.4614H19.8615C19.1784 13.2728 18.5161 13.5744 17.4087 13.5744C15.8252 13.5744 14.6557 12.7319 14.3349 11.3796H22.9456C23.0181 11.0364 23.0595 10.6931 23.0491 10.3394C23.0388 6.86521 20.617 4.32715 17.3052 4.32715ZM14.2417 9.0184C14.6661 7.59334 15.7528 6.8028 17.3362 6.8028C18.9818 6.7924 20.0685 7.58294 20.3997 9.0184H14.2417Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.67016 0.862305H0V10.4633C0 14.1455 2.0285 16.0283 4.8539 16.0283C7.7 16.0283 9.7285 14.1663 9.7285 10.4633V9.00699H7.04798V10.4633C7.04798 12.7309 6.18898 13.4382 4.86425 13.4382C3.49812 13.4382 2.65981 12.7101 2.65981 10.4633V6.78098H9.7285V4.33654H2.67016V0.862305Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.1821 4.32715C44.1614 4.32715 44.1304 4.32715 44.0993 4.32715C40.8807 4.34795 38.3036 6.99003 38.3243 10.2146C38.3243 13.4912 40.9531 16.0293 44.3477 16.0293C46.5936 16.0293 48.9015 14.7602 49.6467 12.4614H46.7385C46.0554 13.2728 45.393 13.5744 44.2856 13.5744C42.6918 13.5744 41.5327 12.7319 41.2118 11.3796H49.8226C49.895 11.0364 49.9261 10.6931 49.9261 10.3394C49.9261 6.86521 47.494 4.32715 44.1821 4.32715ZM41.1187 9.0184C41.543 7.59334 42.6297 6.8028 44.2132 6.8028C45.8588 6.7924 46.9454 7.58294 47.287 9.0184H41.1187Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.9453 4.43155H76.1006L76.0902 4.93084H76.173V4.43155H76.3593V4.36914H75.9453V4.43155Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M69.984 4.36914C66.7549 4.36914 64.1055 7.01122 64.1055 10.215C64.1055 13.4396 66.7549 16.0609 70.0047 16.0609C71.1535 16.0609 72.2712 15.728 73.2337 15.1039V16.0609H75.9245V10.2982C75.9245 6.96961 73.3372 4.36914 69.984 4.36914ZM70.0254 13.606C68.2142 13.606 66.7963 12.0977 66.7963 10.1734C66.7963 8.34266 68.266 6.82399 70.0047 6.82399C71.7951 6.82399 73.2337 8.35306 73.2337 10.215C73.244 12.0977 71.7951 13.606 70.0254 13.606Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.9802 4.35742H76.887L76.7835 4.62787C76.7525 4.70068 76.7318 4.7631 76.7214 4.8151C76.7111 4.75269 76.6904 4.70068 76.6697 4.62787L76.5765 4.35742H76.4834L76.4316 4.91912H76.5041L76.5248 4.67988C76.5351 4.59667 76.5351 4.50305 76.5351 4.43023C76.5455 4.49265 76.5662 4.56546 76.5972 4.64867L76.6904 4.91912H76.7318L76.8353 4.64867C76.8663 4.57586 76.887 4.50305 76.9077 4.44064C76.9077 4.51345 76.9181 4.59667 76.9181 4.67988L76.9388 4.91912H77.0112L76.9802 4.35742Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.0506 -0.0107422C60.1812 -0.0107422 59.4878 0.686185 59.4982 1.54954C59.4982 2.4129 60.1916 3.10983 61.0506 3.10983C61.9096 3.10983 62.603 2.4129 62.603 1.54954C62.603 0.686185 61.9096 -0.0107422 61.0506 -0.0107422Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M62.4084 4.59668H59.7383V16.0388H62.4084V4.59668Z",
    fill: "#1B315E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M57.2321 4.59668C54.3135 4.59668 51.9021 6.86429 51.6848 9.77682C51.6744 9.91205 51.6641 10.0369 51.6641 10.1721C51.6641 11.6388 51.6848 16.0492 51.6848 16.0492H54.3549V10.3489C54.3549 8.45578 55.8763 7.29077 57.7599 7.29077H58.0083L57.9979 4.59668H57.2321Z",
    fill: "#1B315E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2312_5723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogog013);
export default __webpack_public_path__ + "static/media/logo g-01 3.91354840.svg";
export { ForwardRef as ReactComponent };